const normalizeOffset = (offset, modalSize, overlaySize) => {
  const boundaryOffset = offset + modalSize <= overlaySize ? offset : overlaySize - modalSize;
  return boundaryOffset < 0 ? 0 : boundaryOffset;
};

export default normalizeOffset;
